import React from 'react';
import { StyledCategory } from './styled';

interface Props {
  text: string;
}

export const Category: React.FC<Props> = ({ text }) => {
  return (
    <StyledCategory>
      <small className="category category--pill">{text}</small>
    </StyledCategory>
  );
};
